import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-911fa748"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "upload-file-item" }
const _hoisted_2 = {
  key: 1,
  class: "upload-status"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uploading-cover" }, null, -1))
const _hoisted_4 = { class: "status-text" }
const _hoisted_5 = {
  key: 2,
  class: "upload-success"
}
const _hoisted_6 = ["src"]

import { v4 as uuidV4 } from 'uuid'
import { Loading, Icon } from 'vant'
import { UploadEnums } from '@/enums/upload'
// import { s3UploadWrap } from '@/utils/aws-s3'
import { UploadFileDataItem } from '@/types/public'
import { computed, onMounted, withDefaults, watch } from 'vue'
import {
  judgeFileUrlIsImage,
  judgeFileUrlIsVidoe,
  getFileUrlSuffixNameIconClass,
} from '@/utils/common'

import IconAdd from '@/components/icon/IconAdd.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UploadFile',
  props: {
    onlyCheck: { type: Boolean },
    uploadHandle: null,
    fileInfo: { default: () => ({}) }
  },
  emits: [
  'beforeStart',
  'preview',
  'previewVideo',
  'click',
  'change',
  'delete',
  'start',
  'success',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { onlyCheck: boolean, uploadHandle: (
      data: {
        file: File
      } & any
    ) => any, fileInfo: {
      status?: UploadEnums | ''
      key?: string
      file?: null | File
      url?: string
      uuid?: string
      guid?: string
    } };




const isUploading = computed(() => {
  return props.fileInfo.status === UploadEnums.Uploading
})
const isUploadSuccess = computed(() => {
  return props.fileInfo.status === UploadEnums.Success
})
const isWait = computed(() => {
  return props.fileInfo.status === UploadEnums.Wait || !props.fileInfo.status
})
const isUploadFail = computed(() => {
  return props.fileInfo.status === UploadEnums.Fail
})
const statusText = computed(() => {
  return isUploading.value ? '上传中' : isUploadFail.value ? '上传失败' : ''
})
const previewSrc = computed(() => {
  if (props.fileInfo.file) {
    const blobUrl = URL.createObjectURL(props.fileInfo.file)
    return blobUrl
  }
  if (props.fileInfo.url) {
    return props.fileInfo.url
  }
  return ''
})
const isImage = computed(() => {
  let value = props?.fileInfo?.url || props?.fileInfo?.key
  if (!value) {
    return false
  }
  return judgeFileUrlIsImage(value)
})
const isVideo = computed(() => {
  let value = props?.fileInfo?.url || props?.fileInfo?.key
  if (!value) {
    return false
  }
  return judgeFileUrlIsVidoe(value)
})
const fileIconClass = computed(() => {
  let value = props?.fileInfo?.url || props?.fileInfo?.key
  if (!value) {
    return ''
  }
  return getFileUrlSuffixNameIconClass(value)
})
watch(
  () => props.fileInfo,
  () => {
    taskExcute()
  },
  {
    deep: true,
  }
)
function taskExcute() {
  if (props.fileInfo.status === UploadEnums.WaitUpload) {
    // 开始上传任务
    startFileUploadTask()
  }
}
function startUpload() {
  emits('beforeStart')
}
// 更改状态
function uploadInfoStatusChange(status: UploadFileDataItem['status']) {
  changeHandleWrap({ status })
}
async function startFileUploadTask() {
  const file = props.fileInfo.file
  if (!file) {
    return
  }
  uploadInfoStatusChange(UploadEnums.Uploading)
  try {
    const data = await uploadHandle(file)
    emits('change', {
      ...props.fileInfo,
      ...data,
      key: data?.key || '',
      file: data?.file || file,
      status: UploadEnums.Success,
      guid: data?.guid,
    })
    emits('success')
  } catch (error) {
    uploadInfoStatusChange(UploadEnums.Fail)
    console.log('error', error)
  }
}

// 上传处理函数
async function uploadHandle(file: File) {
  if (!file) {
    return
  }
  try {
    const formData = new FormData()
    formData.append('file', file)
    const data = await props.uploadHandle(formData)
    return data
  } catch (error) {
    console.log('error', error)
    return Promise.reject(error)
  }
}
// 更新数据
function changeHandleWrap(data: Partial<UploadFileDataItem>) {
  const result = {
    ...props.fileInfo,
    ...data,
  }
  result.uuid ??= uuidV4()
  emits('change', result)
}
// 预览事件
function previewHandle() {
  emits('preview', props.fileInfo)
}
// 预览文件时间
function previewFileHandle() {
  if (isVideo.value) {
    emits('previewVideo', props.fileInfo)
  }
}
// 删除事件
function deleteHandle() {
  emits('delete', props.fileInfo)
}

onMounted(() => {
  taskExcute()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isWait))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "before-upload",
          onClick: startUpload
        }, [
          _createVNode(_unref(Icon), {
            name: "plus",
            size: 20
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(isUploading) || _unref(isUploadFail))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          (_unref(isUploadFail))
            ? (_openBlock(), _createBlock(_unref(Icon), {
                key: 0,
                name: "close",
                size: "22"
              }))
            : _createCommentVNode("", true),
          (_unref(isUploading))
            ? (_openBlock(), _createBlock(_unref(Loading), {
                key: 1,
                color: "white",
                size: "22"
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(statusText)), 1)
        ]))
      : _createCommentVNode("", true),
    (_unref(isUploadSuccess))
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_unref(isImage))
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _unref(previewSrc),
                alt: "",
                class: "preview-item",
                onClick: previewHandle
              }, null, 8, _hoisted_6))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: _normalizeClass(["upload-success-file-item", _unref(fileIconClass)]),
                onClick: previewFileHandle
              }, null, 2))
        ]))
      : _createCommentVNode("", true),
    (!_unref(isWait) && !_unref(isUploading) && !__props.onlyCheck)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: "close-item",
          onClick: deleteHandle
        }, [
          _createVNode(_unref(Icon), {
            name: "cross",
            size: "10"
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})